import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "e-library-management";


export type list_borrow = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
    is_booked?: number; //1\0
    library_history_status?: string;
}

export type list_order_buy = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
    library_payment_status?: string;
}
export type approve_or_reject_payment = {
    id_library_payment_head: number;
    library_payment_head_status: string;
}
export type booked_book = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
}

export type update_number_book = {
    id_library_payment_detail: number;
    id_library_history: number;
    id_library_detail_old: number;
    id_library_detail_new: number;
}

export type report_data_e_library = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    action?: string;
    start_date?: string;
    end_date?: string;
    library_category_name?: string;
    type_user?: number
}
export type report_period_data_e_library = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    start_date?: string;
    end_date?: string;
    type: string;
}

export class ELibraryManagementApi extends BaseAPI {
    static listBorrow(params: list_borrow): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/borrow`, { params })
    }
    static findOneBorrowDetail(id_library_history: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/get-one/${id_library_history}/borrow`)
    }
    static confirmOrder(id_library_history: number): Promise<AxiosResponse> {
        return this.api.patch(`${path}/library_history/${id_library_history}/confirm-borrow`)
    }
    static returnOrder(id_library_history: number, body: { id_library_detail: number }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/library_history/${id_library_history}/confirm-borrow-return`, body)
    }
    static deleteBorrow(id_library_history: number,): Promise<AxiosResponse> {
        return this.api.delete(`${path}/library_history/${id_library_history}/borrow`)
    }
    static listOrderBuy(params: list_order_buy): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/order-buy`, { params })
    }
    static findOnePayment(id_library_payment_head: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/get-one/library-payment/${id_library_payment_head}/order`)
    }
    static approveOrReject(body: approve_or_reject_payment): Promise<AxiosResponse> {
        return this.api.patch(`${path}/library-payment/approve-or-reject`, body)
    }
    static listNumberItem(id_library_head: number, library_detail_type: string, id_library_details_in: string): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/library-head/${id_library_head}/number-item`, { params: { library_detail_type, id_library_details_in } })
    }
    static listBookedBook(id_library_head: number, params: booked_book): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/library_head/${id_library_head}/booked-book`, { params })
    }
    static updateNumberBook(body: update_number_book[]): Promise<AxiosResponse> {
        return this.api.patch(`${path}/library-history/update-number-book`, body)
    }
    static listReport(params: report_data_e_library): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/report/data`, { params })
    }
    static listPeriod(params: report_period_data_e_library): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/report/chart-date`, { params })
    }
}